{
  "guest": [
    {
      "width": 0,
      "firstElementInDropdown": "ALL",
      "dotAllowed": true
    },
    {
      "width": 768,
      "firstElementInDropdown": null,
      "dotAllowed": false
    }
  ],
  "user": [
    {
      "width": 0,
      "firstElementInDropdown": "ALL",
      "dotAllowed": true
    },
    {
      "width": 768,
      "firstElementInDropdown": "account",
      "dotAllowed": false
    }
  ],
  "manager": [
    {
      "width": 0,
      "firstElementInDropdown": "ALL",
      "dotAllowed": false
    },
    {
      "width": 768,
      "firstElementInDropdown": "christmasHub",
      "dotAllowed": false
    },
    {
      "width": 920,
      "firstElementInDropdown": "leads",
      "dotAllowed": false
    },
    {
      "width": 1050,
      "firstElementInDropdown": "settings",
      "dotAllowed": false
    }
  ],
  "corporateBusinessMinWidth": 1150,
  "breakpoints": [
    768,
    920,
    1050,
    1150
  ]
}